/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
import cloneDeepLib from 'lodash-es/cloneDeep';

export function cloneDeep<T>(object: T): T {
  return cloneDeepLib(object);
}
